import { useState } from "react";
import "./styles/Button.css";

const Button = ({ variant = "default", disableShadow, disabled, icon, size, color }) => {
  // STATE
  const [focused, setFocused] = useState(false),
    [hovered, setHovered] = useState(false),
    [hideShadow, setHideShadow] = useState(false),
    [disabledBtn, setDisabledBtn] = useState(disabled),
    [startIcon, setStartIcon] = useState(true);

  const stateCondition = (focused || hovered) && !disableShadow,
    startIconCondition = icon && startIcon,
    endIconCondition = icon && !startIcon;

  let btnClassName = variant,

    sizeClassName = size === "sm" ? " size-sm" :
      size === "md" ? " size-md" :
        size === "lg" ? " size-lg" : "",

    colorClassName = color === "primary" ? " btn-color btn-primary" :
      color === "secondary" ? " btn-color btn-secondary" :
        color === "danger" ? " btn-color btn-danger" : "";


  // HANDLERS
  const changeState = (action, bool) => {
    if (action === "hover") {
      setHovered(bool);

    } else setFocused(bool);
  };

  const toggleClick = () => {
    if (disableShadow) setHideShadow(!hideShadow);

    if (disabled) setDisabledBtn(!disabledBtn);

    if (icon) setStartIcon(!startIcon);
  };

  return (
    <div>
      <p>
        {`<Button ${variant !== "default" ? `variant="${variant}"` : ""} ${disabledBtn ? "disabled" : ""} ${disableShadow ? "disableShadow" : ""} ${startIconCondition ? ` startIcon="${icon}"` : endIconCondition ? `endIcon="${icon}"` : ""} ${size ? `size="${size}"` : ""} ${color ? `color="${color}"` : ""} />`}
      </p>
      <button
        className={`${btnClassName}${stateCondition ? " default-hovered-focused" : ""}${hideShadow ? " disabled-shadow" : ""}${disabledBtn ? " disabled" : ""}${sizeClassName}${colorClassName}`}
        onClick={toggleClick}
        onMouseOver={() => changeState("hover", true)}
        onMouseLeave={() => changeState("hover", false)}
        onFocus={() => changeState("focus", true)}
        onBlur={() => changeState("focus", false)}
      >
        {startIconCondition && <i className={`${icon} start-icon`}></i>}
        {disabledBtn ? "Disabled" :
          color === "secondary" ? "Secondary" :
            color === "danger" ? "Danger" : "Default"}
        {endIconCondition && <i className={`${icon} end-icon`}></i>}
      </button>
    </div>
  );
}

export default Button;